// 2026-07-18: The NEW_API_1 (fm_export_*) services are JWT-enforced. Attach the
// unified-login JWT (stored at login) as a Bearer header. Returns just Content-Type
// before login / when no token is present.
export default function authHeaders() {
  const t = localStorage.getItem('gstart_token');
  const h = { 'Content-Type': 'application/json' };
  if (t) h['Authorization'] = 'Bearer ' + t;
  return h;
}
